import { MotionConfig } from 'framer-motion'
import { RouterProvider } from 'react-router-dom'
import { router } from './Router'
import { MaintenanceWatcher } from './shared/components/MaintenanceWatcher'

export const App = () => {
  return (
    // 'user' keeps exits; global skip broke the stepper
    <MotionConfig reducedMotion='user'>
      <MaintenanceWatcher />
      <RouterProvider router={router} />
    </MotionConfig>
  )
}
